import { Input, ListGroupItem } from "reactstrap";
import { CyMultiSelectableList } from "./CyMultiSelectableList";

interface Props {
  setSelectionList: (
    value: ((prevState: string[]) => string[]) | string[],
  ) => void;
  amountOfSelectedEntries: "all" | "none" | "some";
  selectAllVisible: () => void;
}

export function HeaderEntryCheckboxColumn({
  setSelectionList,
  amountOfSelectedEntries,
  selectAllVisible,
}: Props) {
  return (
    <ListGroupItem
      className={
        "d-flex with-left-column col-auto fs-4 align-items-center justify-content-center border-0 bg-light"
      }
      onClick={() => {
        if (amountOfSelectedEntries === "all") {
          setSelectionList([]);
        } else {
          selectAllVisible();
        }
      }}
    >
      <Input
        type="checkbox"
        className="m-0"
        color="primary"
        innerRef={(input: HTMLInputElement) => {
          if (input) {
            input.indeterminate = amountOfSelectedEntries === "some";
          }
        }}
        data-cy={CyMultiSelectableList.CheckboxToggleAll}
        checked={
          amountOfSelectedEntries === "all" ||
          amountOfSelectedEntries === "some"
        }
        readOnly
      />
    </ListGroupItem>
  );
}
